exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-item[data-v-e975d4de] {\n  display: inline;\n}\n", ""]);

// exports
